// src/config/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCS01cOaAcYpnbmPP1LVq1X8NznabZ0ed4",
  authDomain: "findmyvenueprod.firebaseapp.com",
  projectId: "findmyvenueprod",
  storageBucket: "findmyvenueprod.firebasestorage.app",
  messagingSenderId: "1028246198089",
  appId: "1:1028246198089:web:53cb082e371888cd0bac98",
  measurementId: "G-Y8TPFJD9R0"
};


export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);